// Tipos de preguntas médicas profesionales

export const DIFFICULTY_LEVELS = {
  BASICO: 'basico',
  GENERAL: 'general',
  COMPLEJO: 'complejo'
};

export const QUESTION_TYPES = {
  CONCEPTO: 'concepto',                    // Definiciones y conceptos básicos
  IDENTIFICACION: 'identificacion',        // Identificación de estructuras
  RELACION: 'relacion',                    // Relaciones anatómicas
  FUNCION: 'funcion',                      // Función y fisiología
  VASCULARIZACION: 'vascularizacion',      // Irrigación arterial
  INERVACION: 'inervacion',                // Inervación
  CASO_CLINICO: 'caso_clinico',            // Casos clínicos aplicados
  DIAGNOSTICO: 'diagnostico',              // Diagnóstico diferencial
  CORRELACION_CLINICA: 'correlacion_clinica', // Correlación anatomoclínica
  QUIRURGICA: 'quirurgica',                // Aplicación quirúrgica
  IMAGENOLOGIA: 'imagenologia',            // Interpretación de imágenes
  VARIANTE: 'variante',                    // Variantes anatómicas
  EMBRIOLOGIA: 'embriologia',              // Desarrollo embriológico
  HISTOLOGIA: 'histologia',                // Estructura microscópica
  VERDADERO_FALSO: 'verdadero_falso'       // Preguntas de verdadero/falso
};

export const difficultyConfig = {
  [DIFFICULTY_LEVELS.BASICO]: {
    label: 'Básico',
    description: 'Conceptos fundamentales y estructuras principales',
    color: 'green',
    icon: '📗'
  },
  [DIFFICULTY_LEVELS.GENERAL]: {
    label: 'General',
    description: 'Conocimiento intermedio y relaciones anatómicas',
    color: 'blue',
    icon: '📘'
  },
  [DIFFICULTY_LEVELS.COMPLEJO]: {
    label: 'Complejo',
    description: 'Casos clínicos, cirugía y diagnóstico avanzado',
    color: 'red',
    icon: '📕'
  }
};

export const questionTypeConfig = {
  [QUESTION_TYPES.CONCEPTO]: {
    label: 'Concepto',
    description: 'Definiciones y conceptos fundamentales',
    icon: '💡'
  },
  [QUESTION_TYPES.IDENTIFICACION]: {
    label: 'Identificación',
    description: 'Identificar estructuras anatómicas',
    icon: '🔍'
  },
  [QUESTION_TYPES.RELACION]: {
    label: 'Relación',
    description: 'Relaciones espaciales entre estructuras',
    icon: '🔗'
  },
  [QUESTION_TYPES.FUNCION]: {
    label: 'Función',
    description: 'Función fisiológica de estructuras',
    icon: '⚙️'
  },
  [QUESTION_TYPES.VASCULARIZACION]: {
    label: 'Vascularización',
    description: 'Irrigación arterial y drenaje venoso',
    icon: '🩸'
  },
  [QUESTION_TYPES.INERVACION]: {
    label: 'Inervación',
    description: 'Nervios y su distribución',
    icon: '⚡'
  },
  [QUESTION_TYPES.CASO_CLINICO]: {
    label: 'Caso Clínico',
    description: 'Aplicación clínica práctica',
    icon: '🏥'
  },
  [QUESTION_TYPES.DIAGNOSTICO]: {
    label: 'Diagnóstico',
    description: 'Diagnóstico diferencial',
    icon: '🔬'
  },
  [QUESTION_TYPES.CORRELACION_CLINICA]: {
    label: 'Correlación Clínica',
    description: 'Correlación anatomoclínica',
    icon: '📊'
  },
  [QUESTION_TYPES.QUIRURGICA]: {
    label: 'Quirúrgica',
    description: 'Aplicación quirúrgica',
    icon: '✂️'
  },
  [QUESTION_TYPES.IMAGENOLOGIA]: {
    label: 'Imagenología',
    description: 'Interpretación de imágenes médicas',
    icon: '📸'
  },
  [QUESTION_TYPES.VARIANTE]: {
    label: 'Variante',
    description: 'Variantes anatómicas',
    icon: '🔄'
  },
  [QUESTION_TYPES.EMBRIOLOGIA]: {
    label: 'Embriología',
    description: 'Desarrollo embriológico',
    icon: '🧬'
  },
  [QUESTION_TYPES.HISTOLOGIA]: {
    label: 'Histología',
    description: 'Estructura microscópica',
    icon: '🔬'
  },
  [QUESTION_TYPES.VERDADERO_FALSO]: {
    label: 'Verdadero/Falso',
    description: 'Afirmaciones que deben clasificarse como verdaderas o falsas',
    icon: '✅❌'
  }
};
